import {store} from './store';
import {Module, VuexModule, Mutation, Action} from 'vuex-module-decorators';
import {iNomCategOfEvents} from '@/types/iNomCategOfEvents';
import {iNomTypesOfEvents} from '@/types/iNomTypesOfEvents';

@Module({ namespaced: true, dynamic: true, store, name: 'storeNomenclatures'})
export default class Nomenclatures extends VuexModule {
    nom_types_of_events:Array<iNomTypesOfEvents>=[];
    nom_categ_of_events:Array<iNomCategOfEvents>=[];

    @Mutation
    SET_NOM_TYPES_OF_EVENTS(pnom_types_of_events:Array<iNomTypesOfEvents>){
        this.nom_types_of_events=JSON.parse(JSON.stringify(pnom_types_of_events));
    }
    @Action
    set_nom_types_of_events(pnom_types_of_events:Array<iNomTypesOfEvents>){
        this.context.commit('SET_NOM_TYPES_OF_EVENTS',pnom_types_of_events);
    }


    @Mutation
    SET_NOM_CATGE_OF_EVENTS(pnom_types_of_events:Array<iNomCategOfEvents>){
        this.nom_categ_of_events=JSON.parse(JSON.stringify(pnom_types_of_events));
    }
    @Action
    set_nom_categ_of_events(pnom_types_of_events:Array<iNomCategOfEvents>){
        this.context.commit('SET_NOM_CATGE_OF_EVENTS',pnom_types_of_events);
    }
}
